/* eslint-disable import/no-unresolved */
import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

export const DesktopContainer = styled.div`
  display: flex;
  padding: 36px 24px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  margin-top: 24px;
  flex-direction: column;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  align-self: stretch;
  text-align: center;
`;

export const TextContainer = styled.div`
  text-align: center;
  width: 100%;
`;

export const IslandItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const IslandItems = styled.div`
  width: 300px;
  height: 300px;
`;

export const TextContainerBottomDescription = styled.div`
  text-align: center;
  width: 1040px;
  margin-left: auto;
  margin-right: auto;
`;

export const MobileContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  display: flex;
  padding: 12px 0px 12px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const TextContainerMobile = styled.div`
  padding-right: 12px;
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  .swiper-slide {
    height: 300px;
  }
`;
